const ProjectContants = 
{   
    HTML_VARIABLES:{
        EDIT : "EDIT TASK",
        ADD: "ADD TASK",
        REMOVE:"REMOVE TASK",
        DONE:"COMPLETE TASK",
        SAVE:"SAVE CHANGES",
        CANCEL:"CANCEL"
    },
    USER_MSG:
    {
        EDIT:"Update Task",
        DONE:"Done",
        CONGRATULATION:"Congratulations !!",
        COMPLETE:"Task is Complete"


    }
};


export default Object.freeze(ProjectContants);
